/*
 * @Description:业务插件管理--容联外呼人员管理/外呼人员管理/外呼池管理
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  条: 'item',
  备注: 'remark',
  新建: 'new',
  号码: 'number',
  移除: 'remove',
  员工: 'employee',
  操作: 'operation',
  固话: 'landline',
  已选择: 'selected',
  管理员: 'administrator',
  创建人: 'creator',
  号码池: 'number pool',
  所属部门: 'Department',
  普通坐席: 'ordinary seat',
  创建时间: 'Creation time',
  号码详情: 'number details',
  新增号码: 'add a number',
  号码数量: 'number of numbers',
  外呼号码: 'outgoing call number',
  号码状态: 'number status',
  最后更新人: 'Last updater',
  主叫号码池: 'caller number pool',
  被叫号码池: 'called number pool',
  请选择员工: 'please select an employee',
  请输入号码: 'please enter the number',
  号码归属地: 'number attribution',
  外呼池管理: 'outgoing pool management',
  新增号码池: 'new number pool',
  外呼池名称: 'outgoing call pool name',
  外呼池编号: 'outgoing call pool number',
  所属归属池: 'belonging attribution pool',
  外呼中间号: 'outgoing intermediate number',
  外呼号码管理: 'outgoing call number management',
  搜索外呼号码: 'search outgoing call number',
  外呼人员管理: 'outcall personnel management',
  被叫外显号码: 'called display number',
  主叫外显号码: 'caller display number',
  最后更新时间: 'Last update time',
  绑定员工姓名: 'bind employee name',
  外呼系统工号: 'outcall system work number',
  外呼系统角色: 'outcall system role',
  设置默认号码: 'set default number',
  默认拨打号码: 'default call number',
  请选择员工姓名: 'please select the employee name',
  员工个人手机号: 'cell-phone number',
  主叫号码池编号: 'caller number pool number',
  主叫号码池名称: 'caller number pool name',
  被叫号码池编号: 'called number pool number',
  被叫号码池名称: 'called number pool name',
  绑定员工手机号: 'cell-phone number',
  绑定外呼中间号: 'bind outgoing intermediate number',
  确认移除该号码: 'confirm removal of this number',
  解绑的外呼中间号: 'unbound outgoing intermediate number',
  绑定的外呼中间号: 'bound outgoing intermediate number',
  获取固话列表失败: 'landline list retrieval failed',
  只能选择一个员工: 'only one employee can be selected',
  请选择主叫号码池: 'please select the caller number pool',
  请选择被叫号码池: 'please select the called number pool',
  请输入外呼池编号: 'please enter the outgoing call pool number',
  请输入外呼池名称: 'please enter the outgoing call pool name',
  请输入号码归属地: 'please enter the numbers assigned area',
  设置默认外呼中间号: 'set default outgoing intermediate number',
  批量编辑主叫号码池: 'batch edit caller number pool',
  批量编辑被叫号码池: 'batch edit called number pool',
  批量绑定外呼中间号: 'batch bind outgoing intermediate number',
  批量解绑外呼中间号: 'batch unbind outgoing intermediate number',
  移除后该号码将不能使用: 'the number cannot be used after removal',
  批量设置默认外呼中间号: 'batch set default outgoing intermediate number',
  请输入绑定员工手机号: 'please enter the bind employee mobile phone number',
  输入外呼系统工号: 'Enter Outbound System Employee Number',
  搜索号码: 'Search Number',
  请选择外呼系统角色: 'Please choose the role of the outbound call system',
  容联外呼人员管理: 'Outbound staff management',
  容联外呼中间号: 'Accept the middle sign of the outbound call'
};
